import React from 'react';
import {isNil} from 'lodash';

import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import NavigationHeader from '/component/layout/NavigationHeader';
import OrderDetail from '/component/partial/OrderDetail';
import OrderHistoryList from '/component/partial/OrderHistoryList';
import AccountSettings from '/component/partial/setting/AccountSettings';
import NotificationSettings from '/component/partial/setting/NotificationSettings';
import SecuritySettings from '/component/partial/setting/SecuritySettings';
import {Bonuses} from '/component/screen/Bonuses';
import {CandidateProfile} from '/component/screen/CandidateProfile';
import {CreateCandidateProfile} from '/component/screen/CandidateProfile/CreateCandidateProfile';
import ClientProfile from '/component/screen/ClientProfile';
import {ShareOptaviaPlan} from '/component/screen/Clients/ShareOptaviaPlan';
import CoachProfile from '/component/screen/CoachProfile';
import {Edge365ChallengeScreen} from '/component/screen/Dashboard/Edge365/Edge365ChallengeScreen/Edge365ChallengeScreen';
import Notifications from '/component/screen/Notifications';
import HealthcareProviderScreen from '/component/screen/Profile/ProfileBusinessSection/HealthcareProvider';
import ManageMySiteContainer from '/component/screen/Profile/ProfileBusinessSection/ManageMySite/ManageMySiteContainer';
import {ReferralProfile} from '/component/screen/ReferralProfile';
import {ReleaseNotes as ReleaseNotesScreen} from '/component/screen/ReleaseNotes';
import {AllCandidatesReport} from '/component/screen/report/AllCandidatesReport';
import AllFrontlineClientsReport from '/component/screen/report/AllFrontlineClientsReport';
import AllFrontlineCoachesReport from '/component/screen/report/AllFrontlineCoachesReport';
import AllFrontlineOrdersReport from '/component/screen/report/AllFrontlineOrdersReport';
import AllGen0ClientsReport from '/component/screen/report/AllGen0ClientsReport';
import AllGen0CoachesReport from '/component/screen/report/AllGen0CoachesReport';
import AllGen0OrdersReport from '/component/screen/report/AllGen0OrdersReport';
import AllOrdersReport from '/component/screen/report/AllOrdersReport';
import AllOrganizationClientsReport from '/component/screen/report/AllOrganizationClientsReport';
import AllOrganizationCoachesReport from '/component/screen/report/AllOrganizationCoachesReport';
import AllOrganizationOrdersReport from '/component/screen/report/AllOrganizationOrdersReport';
import {AllReferralsReport} from '/component/screen/report/AllReferralsReport';
import {BusinessBuilderCoachesReport} from '/component/screen/report/BusinessBuilderCoachesReport';
import ClientsExpiringRewardsReport from '/component/screen/report/ClientsExpiringRewardsReport';
import CoachesAboveRankReport from '/component/screen/report/CoachesAboveRankReport';
import CoachesAtRankReport from '/component/screen/report/CoachesAtRankReport';
import CoachesBelowRankReport from '/component/screen/report/CoachesBelowRankReport';
import EarnedAcceleratorBonusReport from '/component/screen/report/EarnedAcceleratorBonuReport';
import EarnedCabReport from '/component/screen/report/EarnedCabReport';
import {EarnedClientSupportBonusPlusReport} from '/component/screen/report/EarnedClientSupportBonusPlusReport';
import EarnedQsbReport from '/component/screen/report/EarnedQsbReport';
import EligibleAcceleratorBonusReport from '/component/screen/report/EligibleAcceleratorBonusReport';
import {EligibleClientSupportBonusPlusReport} from '/component/screen/report/EligibleClientSupportBonusPlusReport';
import EligibleForCabReport from '/component/screen/report/EligibleForCabReport';
import EligibleForIncentiveTripReport from '/component/screen/report/EligibleForIncentiveTripReport';
import {EligibleForQsbReport} from '/component/screen/report/EligibleForQsbReport';
import ExecutiveDirectorCloseToRankReport from '/component/screen/report/ExecutiveDirectorCloseToRankReport';
import ExecutiveDirectorTeamsReport from '/component/screen/report/ExecutiveDirectorTeamsReport';
import ExpiringCoachRenewalReport from '/component/screen/report/ExpiringCoachRenewalReport';
import ExpiringWellnessClientsReport from '/component/screen/report/ExpiringWellnessClientsReport';
import FibcCloseToRankReport from '/component/screen/report/FibcCloseToRankReport';
import FibcTeamsReport from '/component/screen/report/FibcTeamsReport';
import FiblTeamsReport from '/component/screen/report/FiblTeamsReport';
import FrontlineCoachesReport from '/component/screen/report/FrontlineCoachesReport';
import InactiveClientsReport from '/component/screen/report/InactiveClientsReport';
import MyTeams from '/component/screen/report/MyTeamsReport';
import NewClientsWithoutOrdersReport from '/component/screen/report/NewClientsWithoutOrdersReport';
import NewFrontlineClientsReport from '/component/screen/report/NewFrontlineClientsReport';
import NewFrontlineCoachesReport from '/component/screen/report/NewFrontlineCoachesReport';
import NewFrontlineOrdersReport from '/component/screen/report/NewFrontlineOrdersReport';
import NewGen0ClientsReport from '/component/screen/report/NewGen0ClientsReport';
import NewGen0CoachesReport from '/component/screen/report/NewGen0CoachesReport';
import NewGen0OrdersReport from '/component/screen/report/NewGen0OrdersReport';
import NewOrganizationClientsReport from '/component/screen/report/NewOrganizationClientsReport';
import NewOrganizationCoachesReport from '/component/screen/report/NewOrganizationCoachesReport';
import NewOrganizationOrdersReport from '/component/screen/report/NewOrganizationOrdersReport';
import NotCertifiedReport from '/component/screen/report/NotCertifiedReport';
import {PeopleToContactReport} from '/component/screen/report/PeopleToContactReport';
import PremierCancellationsReport from '/component/screen/report/PremierCancellationsReport';
import ProjectedPremierVolumeReport from '/component/screen/report/ProjectedPremierVolumeReport';
import QualifiedForIncentiveTripReport from '/component/screen/report/QualifiedForIncentiveTripReport';
import RankUpReport from '/component/screen/report/RankUpReport';
import SeniorCoachCloseToRankReport from '/component/screen/report/SeniorCoachCloseToRankReport';
import SeniorCoachTeamsReport from '/component/screen/report/SeniorCoachTeamsReport';
import VolumePerformanceReport from '/component/screen/report/VolumePerformanceReport';
import {Search} from '/component/screen/Search';
import {TestingOptions} from '/component/screen/TestingOptions';
import {
  ACCOUNT_SETTINGS,
  BONUSES,
  CANDIDATE_PROFILE,
  CLIENT_PROFILE,
  COACH_PROFILE,
  CREATE_NEW_CANDIDATE,
  NOTIFICATION_SETTINGS,
  NOTIFICATIONS,
  REFERRAL_PROFILE,
  RELEASE_NOTES,
  SEARCH,
  SECURITY_SETTINGS,
  TESTING_OPTIONS,
} from '/enum/popover.enum';
import {
  HEALTH_CARE_PROVIDER,
  MANAGE_MY_SITE,
  MY_TEAMS,
  ORDER_DETAILS,
  ORDER_HISTORY_LIST_SCREEN,
  REPORT_ALL_CANDIDATES,
  REPORT_ALL_COACHES_IN_ORGANIZATION,
  REPORT_ALL_FRONTLINE_CLIENTS,
  REPORT_ALL_FRONTLINE_COACHES,
  REPORT_ALL_FRONTLINE_ORDERS,
  REPORT_ALL_GEN0_CLIENTS,
  REPORT_ALL_GEN0_COACHES,
  REPORT_ALL_GEN0_ORDERS,
  REPORT_ALL_ORDERS,
  REPORT_ALL_ORGANIZATION_CLIENTS,
  REPORT_ALL_ORGANIZATION_ORDERS,
  REPORT_ALL_REFERRALS,
  REPORT_BUSINESS_BUILDER_COACHES,
  REPORT_CLIENT_TO_CONTACT,
  REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK,
  REPORT_CLOSE_TO_FIBC_RANK,
  REPORT_CLOSE_TO_SENIOR_COACH_RANK,
  REPORT_COACHES_ABOVE_RANK,
  REPORT_COACHES_AT_RANK,
  REPORT_COACHES_BELOW_RANK,
  REPORT_EARNED_ACCELERATOR_BONUS,
  REPORT_EARNED_CAB,
  REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_EARNED_QSB,
  REPORT_ELIGIBLE_ACCELERATOR_BONUS,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR,
  REPORT_ELIGIBLE_FOR_CAB,
  REPORT_ELIGIBLE_FOR_INCENTIVE_TRIP,
  REPORT_ELIGIBLE_FOR_QSB,
  REPORT_EXPIRING_COACH_RENEWAL,
  REPORT_EXPIRING_REWARDS,
  REPORT_EXPIRING_WELLNESS,
  REPORT_FRONTLINE_COACHES,
  REPORT_INACTIVE_CLIENTS,
  REPORT_NEW_CLIENTS_WITHOUT_ORDERS,
  REPORT_NEW_COACHES_IN_ORGANIZATION,
  REPORT_NEW_FRONTLINE_CLIENTS,
  REPORT_NEW_FRONTLINE_COACHES,
  REPORT_NEW_FRONTLINE_ORDERS,
  REPORT_NEW_GEN0_CLIENTS,
  REPORT_NEW_GEN0_COACHES,
  REPORT_NEW_GEN0_ORDERS,
  REPORT_NEW_ORGANIZATION_CLIENTS,
  REPORT_NEW_ORGANIZATION_ORDERS,
  REPORT_NOT_CERTIFIED,
  REPORT_PREMIER_CANCELLATIONS,
  REPORT_PROJECTED_PREMIER_VOLUME,
  REPORT_QUALIFIED_FOR_INCENTIVE_TRIP,
  REPORT_RANK_UP,
  REPORT_TEAMS_EXECUTIVE_DIRECTOR,
  REPORT_TEAMS_FIBC,
  REPORT_TEAMS_FIBL,
  REPORT_TEAMS_SENIOR_COACH,
  REPORT_VOLUME_PERFORMANCE,
} from '/enum/records.enum';
import {
  EDGE365CHALLENGESCREEN,
  SHARE_OPTAVIA_PLAN,
} from '/enum/recordType.enum';

import {FiveToSixCSBPReport} from '../../component/screen/report/FiveToSixCSBPReport';
import {OneToTwoCSBPReport} from '../../component/screen/report/OneToTwoCSBPReport';
import {SevenToNineCSBPReport} from '../../component/screen/report/SevenToNineCSBPReport';
import {ThreeToFourCSBPReport} from '../../component/screen/report/ThreeToFourCSBPReport';

import {styles} from './ScreenRenderer.style';

interface ScreenRendererProps {
  modalType: string;
  modalName: string;
  modalProps: {};
  onClose: () => void;
}

const OrderDetailScreen = (props: any) => (
  <NavigationHeader style={{base: {flex: 1, backgroundColor: 'white'}}}>
    <OrderDetail {...props} />
  </NavigationHeader>
);

const ALL_MODALS = {
  [REPORT_ALL_FRONTLINE_CLIENTS]: AllFrontlineClientsReport,
  [REPORT_ALL_GEN0_CLIENTS]: AllGen0ClientsReport,
  [REPORT_ALL_ORGANIZATION_CLIENTS]: AllOrganizationClientsReport,
  [REPORT_NEW_FRONTLINE_CLIENTS]: NewFrontlineClientsReport,
  [REPORT_NEW_GEN0_CLIENTS]: NewGen0ClientsReport,
  [REPORT_NEW_ORGANIZATION_CLIENTS]: NewOrganizationClientsReport,
  [REPORT_ALL_FRONTLINE_ORDERS]: AllFrontlineOrdersReport,
  [REPORT_ALL_ORDERS]: AllOrdersReport,

  [REPORT_ALL_GEN0_ORDERS]: AllGen0OrdersReport,
  [REPORT_ALL_ORGANIZATION_ORDERS]: AllOrganizationOrdersReport,
  [REPORT_NEW_FRONTLINE_ORDERS]: NewFrontlineOrdersReport,
  [REPORT_NEW_GEN0_ORDERS]: NewGen0OrdersReport,
  [REPORT_NEW_ORGANIZATION_ORDERS]: NewOrganizationOrdersReport,
  [REPORT_PREMIER_CANCELLATIONS]: PremierCancellationsReport,
  [REPORT_PROJECTED_PREMIER_VOLUME]: ProjectedPremierVolumeReport,
  [REPORT_NEW_CLIENTS_WITHOUT_ORDERS]: NewClientsWithoutOrdersReport,
  [REPORT_RANK_UP]: RankUpReport,
  [REPORT_ELIGIBLE_FOR_CAB]: EligibleForCabReport,
  [REPORT_ELIGIBLE_FOR_QSB]: EligibleForQsbReport,
  [REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK]: ExecutiveDirectorCloseToRankReport,
  [REPORT_CLOSE_TO_FIBC_RANK]: FibcCloseToRankReport,
  [REPORT_CLOSE_TO_SENIOR_COACH_RANK]: SeniorCoachCloseToRankReport,
  [REPORT_TEAMS_EXECUTIVE_DIRECTOR]: ExecutiveDirectorTeamsReport,
  [REPORT_TEAMS_FIBC]: FibcTeamsReport,
  [REPORT_TEAMS_FIBL]: FiblTeamsReport,
  [REPORT_TEAMS_SENIOR_COACH]: SeniorCoachTeamsReport,
  [REPORT_EXPIRING_COACH_RENEWAL]: ExpiringCoachRenewalReport,
  [REPORT_COACHES_AT_RANK]: CoachesAtRankReport,
  [REPORT_COACHES_BELOW_RANK]: CoachesBelowRankReport,
  [REPORT_COACHES_ABOVE_RANK]: CoachesAboveRankReport,
  [REPORT_ALL_FRONTLINE_COACHES]: AllFrontlineCoachesReport,
  [REPORT_FRONTLINE_COACHES]: FrontlineCoachesReport,
  [REPORT_NEW_FRONTLINE_COACHES]: NewFrontlineCoachesReport,
  [REPORT_ALL_GEN0_COACHES]: AllGen0CoachesReport,
  [REPORT_NEW_GEN0_COACHES]: NewGen0CoachesReport,
  [REPORT_ALL_COACHES_IN_ORGANIZATION]: AllOrganizationCoachesReport,
  [MY_TEAMS]: MyTeams,
  [REPORT_NEW_COACHES_IN_ORGANIZATION]: NewOrganizationCoachesReport,
  [REPORT_EARNED_CAB]: EarnedCabReport,
  [REPORT_EARNED_QSB]: EarnedQsbReport,
  [REPORT_ELIGIBLE_ACCELERATOR_BONUS]: EligibleAcceleratorBonusReport,
  [REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR]: ThreeToFourCSBPReport,
  [REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX]: FiveToSixCSBPReport,
  [REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE]: SevenToNineCSBPReport,
  [REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO]: OneToTwoCSBPReport,
  [REPORT_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS]:
    EligibleClientSupportBonusPlusReport,
  [REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS]: EarnedClientSupportBonusPlusReport,
  [REPORT_EARNED_ACCELERATOR_BONUS]: EarnedAcceleratorBonusReport,
  [REPORT_NOT_CERTIFIED]: NotCertifiedReport,
  [REPORT_INACTIVE_CLIENTS]: InactiveClientsReport,
  [REPORT_EXPIRING_WELLNESS]: ExpiringWellnessClientsReport,
  [REPORT_EXPIRING_REWARDS]: ClientsExpiringRewardsReport,
  [REPORT_CLIENT_TO_CONTACT]: PeopleToContactReport,
  [REPORT_ELIGIBLE_FOR_INCENTIVE_TRIP]: EligibleForIncentiveTripReport,
  [REPORT_QUALIFIED_FOR_INCENTIVE_TRIP]: QualifiedForIncentiveTripReport,
  [REPORT_ALL_CANDIDATES]: AllCandidatesReport,
  [REPORT_BUSINESS_BUILDER_COACHES]: BusinessBuilderCoachesReport,
  [REPORT_VOLUME_PERFORMANCE]: VolumePerformanceReport,
  [ORDER_DETAILS]: OrderDetailScreen,
  [ORDER_HISTORY_LIST_SCREEN]: OrderHistoryList,

  [NOTIFICATIONS]: Notifications,
  [TESTING_OPTIONS]: TestingOptions,
  [ACCOUNT_SETTINGS]: AccountSettings,
  [NOTIFICATION_SETTINGS]: NotificationSettings,
  [SECURITY_SETTINGS]: SecuritySettings,
  [BONUSES]: Bonuses,
  [SEARCH]: Search,
  [RELEASE_NOTES]: ReleaseNotesScreen,

  [CLIENT_PROFILE]: ClientProfile,
  [COACH_PROFILE]: CoachProfile,
  [CANDIDATE_PROFILE]: CandidateProfile,
  [REFERRAL_PROFILE]: ReferralProfile,
  [REPORT_ALL_REFERRALS]: AllReferralsReport,
  [CREATE_NEW_CANDIDATE]: CreateCandidateProfile,
  [SHARE_OPTAVIA_PLAN]: ShareOptaviaPlan,
  [EDGE365CHALLENGESCREEN]: Edge365ChallengeScreen,
  [MANAGE_MY_SITE]: ManageMySiteContainer,
  [HEALTH_CARE_PROVIDER]: HealthcareProviderScreen,
};

class ScreenRenderer extends React.PureComponent<ScreenRendererProps> {
  constructor(...args: any[]) {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super(...args);

    this.handleModalClose = this.handleModalClose.bind(this);
  }

  handleModalClose() {
    const {onClose} = this.props;
    onClose?.();
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {modalType = '', modalName = '', modalProps = {}} = this.props;

    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const ModalComponent = ALL_MODALS[modalName];

    if (!isNil(ModalComponent)) {
      return <ModalComponent {...modalProps} onClose={this.handleModalClose} />;
    } else {
      return (
        <TouchableOpacity
          style={styles.unknownModal}
          onPress={this.handleModalClose}>
          <Text>
            Unknown modal: {modalName} ({modalType}){' '}
            {JSON.stringify(modalProps)}
          </Text>
        </TouchableOpacity>
      );
    }
  }
}

export default ScreenRenderer;
